import React from 'react'
import { createStyles, makeStyles, Theme, Typography } from 'cs-kevlar-react'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      padding: theme.spacing(8),
    },
  }),
)

export const UnavailableDetails: React.FunctionComponent = () => {
  const classes = useStyles({})

  return (
    <Typography className={classes.content}>
      No additional details are available for this event.
    </Typography>
  )
}
